import * as Cookie from 'js-cookie';
/**
 * 在 header['["X-CSRF-TOKEN'] 中添加 ck
 * ps: 会导致 GET 请求变为 complex request，触发 OPTIONS 请求
 * @param conf
 * @returns
 */
export function headerChallengeKeyInterceptor(conf) {
    conf.headers["X-CSRF-TOKEN"] = Cookie.get("ck");
    conf.xsrfHeaderName = "X-CSRF-TOKEN";
    return conf;
}
/**
 * 在 params 或 data 中添加 ck
 * @param conf
 * @returns
 */
export function payloadChallengeKeyInterceptor(conf) {
    var ck = Cookie.get('ck');
    var method = conf.method;
    if (method === 'get' || method === 'delete' || method === 'head') {
        conf.params = conf.params || {};
        conf.params.ck = ck;
    }
    else {
        conf.data = conf.data || {};
        conf.data.ck = ck;
    }
    return conf;
}
/**
 * axios interceptor 插件，用于自动带上代表豆瓣用户登录信息的 ck cookie
 * @param conf
 */
export var challengeKeyInterceptor = function (conf) {
    var method = conf.method;
    // simple request 尽量不添加额外的 header（避免触发 options 请求，引起古老的跨域 bug）
    if (method === 'get' || method === 'delete' || method === 'head') {
        return payloadChallengeKeyInterceptor(conf);
    }
    else {
        return headerChallengeKeyInterceptor(conf);
    }
};
//# sourceMappingURL=challenge-key.js.map